import { computed } from "vue";
import { clsx } from "clsx";
import useCreateComponentConfig from "../../../composables/useCreateComponentConfig.js";
import { EDrawerElements } from "../types.js";
export function useDrawerConfig(props) {
  const rootClasses = useRootConfig(props);
  const headerClasses = useHeaderConfig();
  const containerButtonClasses = useContainerButtonConfig();
  const containerTitleDescriptionClasses = useContainerTitleDescriptionConfig(props);
  const titleClasses = useTitleConfig();
  const descriptionClasses = useDescriptionConfig();
  const contentClasses = useContentConfig(props);
  return {
    root: rootClasses,
    header: headerClasses,
    containerButton: containerButtonClasses,
    containerTitleDescription: containerTitleDescriptionClasses,
    title: titleClasses,
    description: descriptionClasses,
    content: contentClasses
  };
}
function useRootConfig(props) {
  const { setBase, getClasses } = useCreateComponentConfig();
  setBase(
    EDrawerElements.ROOT,
    clsx({
      /* tw */
      "bg-neutral-primary-elevated fixed inset-x-0 bottom-0 z-[60] flex flex-col overflow-hidden md:left-auto md:h-screen md:max-h-screen md:w-[450px] lg:w-[600px]": true,
      /* tw */
      "max-md:rounded-tl-container-lg max-md:rounded-tr-container-lg max-h-[90vh]": !props.fullHeight,
      /* tw */
      "top-0 h-screen": props.fullHeight
    })
  );
  const classes = computed(() => getClasses(EDrawerElements.ROOT));
  return classes.value;
}
function useHeaderConfig() {
  const { setBase, getClasses } = useCreateComponentConfig();
  setBase(
    EDrawerElements.HEADER,
    /* tw */
    `bg-neutral-primary-elevated sticky top-0 z-[60]`
  );
  const classes = computed(() => getClasses(EDrawerElements.HEADER));
  return classes.value;
}
function useContainerButtonConfig() {
  const { setBase, getClasses } = useCreateComponentConfig();
  setBase(
    EDrawerElements.CONTAINERBUTTON,
    /* tw */
    `absolute right-3 top-3 md:right-4 md:top-4`
  );
  const classes = computed(() => getClasses(EDrawerElements.CONTAINERBUTTON));
  return classes.value;
}
function useContainerTitleDescriptionConfig(props) {
  const { setBase, getClasses } = useCreateComponentConfig();
  setBase(
    EDrawerElements.CONTAINERTITLEDESCRIPTION,
    clsx({
      /* tw */
      "py-sm px-base md:py-base md:pl-lg flex min-h-16 flex-col justify-center md:min-h-20 md:pr-4": true,
      /* tw */
      "mr-[52px] md:mr-16": !props.nonDismissible
    })
  );
  const classes = computed(() => getClasses(EDrawerElements.CONTAINERTITLEDESCRIPTION));
  return classes.value;
}
function useTitleConfig() {
  const { setBase, getClasses } = useCreateComponentConfig();
  setBase(
    EDrawerElements.TITLE,
    /* tw */
    `label-lg md:heading-sm text-neutral-primary line-clamp-2`
  );
  const classes = computed(() => getClasses(EDrawerElements.TITLE));
  return classes.value;
}
function useDescriptionConfig() {
  const { setBase, getClasses } = useCreateComponentConfig();
  setBase(
    EDrawerElements.DESCRIPTION,
    /* tw */
    `paragraph-sm md:paragraph-md text-neutral-tertiary line-clamp-2`
  );
  const classes = computed(() => getClasses(EDrawerElements.DESCRIPTION));
  return classes.value;
}
function useContentConfig(props) {
  const { setBase, getClasses } = useCreateComponentConfig();
  setBase(
    EDrawerElements.CONTENT,
    clsx({
      /* tw */
      "text-neutral-primary flex-1 overflow-y-auto": true,
      /* tw */
      "pt-16 md:pt-20": !props.noContentPadding && !(props.title || props.description),
      /* tw */
      "p-base md:p-lg": !props.noContentPadding,
      /* tw */
      "p-0": props.noContentPadding
    })
  );
  const classes = computed(() => getClasses(EDrawerElements.CONTENT));
  return classes.value;
}
